import blockchain from "../../images/cms_images/blockchain.webp";

export const nodeAssets = {
  node: {
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/emerging/iot.webp`,
      emerging2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/emerging/artificial-intelligence.webp`,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/emerging/ar-vr.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/emerging/big-data.webp`,
      emerging5: blockchain,
      emerging6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/emerging/serverless-devops.webp`,
    },
    process: {
      process1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/discovery.webp`,
      process2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/design.webp`,
      process3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/development.webp`,
      process4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/quality-assurance.webp`,
      process5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/deployment.webp`,
      process6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/process/maintenance.webp`,
    },
    services: {
      service1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/custom-nodejs-development.svg`,
      service2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/nodejs-plugin-development.svg`,
      service3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/nodejs-migration-services.svg`,
      service4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/nodejs-api-development.svg`,
      service5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/nodejs-web-app-development.svg`,
      service6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/services/backend-development-with-nodejs.svg`,
    },
    whyChooseKonstant: {
      reason1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/transparency.svg`,
      reason2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/consistent-delivery.svg`,
      reason3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/flexible-engagement-model.svg`,
      reason4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/experience.svg`,
      reason5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/flawless-communication.svg`,
      reason6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whykonstant/quality-driven-solutions.svg`,
    },
    whyNodejs: {
      benefit1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/great-performance.svg`,
      benefit2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/real-time-applications.svg`,
      benefit3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/one-language.svg`,
      benefit4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/performance-optimization.svg`,
      benefit5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/proactive-community.svg`,
      benefit6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejspage/whynodejs/microservices-architecture.svg`,
    },
    bg: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/nodejs_bg.svg`,
  },
};
